module.exports = __webpack_public_path__ + "assets/fonts/OverpassMono-w700.02f115c18fb4205204f10d7a247cdce9.ttf";